<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form ref="model" :model="model" :rules="rules" label-width="100px">
        <el-form-item label="手机号：" prop="phone">
          <el-input v-if="!dataIn || !dataIn.phone" placeholder="请填写手机号" v-model="model.phone" class="input-width"></el-input>
          <span v-else class="input-width" v-text="model.phone"></span>
        </el-form-item>
        <el-form-item label="学校：" prop="universityId">
          <el-select v-model="model.universityId" placeholder="请选择学校">
            <el-option v-for="item in universityList" :key="item.Key" :label="item.Value" :value="item.Key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓：" prop="lastName">
          <el-input placeholder="请输入驾照，护照，学生证上合法的Legal Name" v-model="model.lastName" class="input-width"></el-input>
        </el-form-item>
        <el-form-item label="名：" prop="firstName">
          <el-input placeholder="请输入驾照，护照，学生证上合法的Legal Name" v-model="model.firstName" class="input-width"></el-input>
        </el-form-item>
        <el-form-item label="邮箱：" prop="email">
          <el-input placeholder="请填写绑定邮箱" v-model="model.email" class="input-width"></el-input>
        </el-form-item>
        <el-form-item label="初始密码：" prop="password">
          <el-scs-password ref="el-scs-password" placeholder="请填写初始密码" v-model="model.password" class="input-width"></el-scs-password>
        </el-form-item>
        <el-form-item label="渠道：" prop="channelId" v-if="isStudyAbroad">
          <el-select v-model="model.channelId" placeholder="请选择渠道" filterable>
            <el-option v-for="item in channelList" :key="item.Key" :label="item.Value" :value="item.Key">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col :span="18" class="footer-left">
          <span v-if="!showError"></span>
          <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
        </el-col>
        <el-col class="footer-right" :span="4">
          <el-button :disabled="submitBtnDisable" :type="submitBtnClass" @click="registerUser">确认注册</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
body .popup-content-area-small {
  min-height: 240px;
  padding: 30px 50px;
}

.el-form-item {
  span {
    height: 40px;
    line-height: 40px;
  }
}

.el-col {
  button {
    line-height: 8px;
    margin-top: 5px;
    margin-left: 10px;
  }
}
</style>

<script>
import { getUniversities } from "../../service/common.service";
import { saveStudentFinancialsInfo } from "../../service/student.service";
import { userRegister } from "../../service/user.service";
import elScsPassword from "../../components/common/el-scs-password";
import {
  getChannelItems
} from "../../service/studyAbroad.service";

export default {
  props: {
    isStudyAbroad: Boolean,
    dataIn: Object
  },
  data() {
    let validatePhone = (rule, value, callback) => {
      let message = "";
      let pattern = /^\d{10,11}$/g;
      let isValid = pattern.test(value);
      if (!!value && !isValid) {
        message = "请输入正确的手机号码";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    let validatePass = (rule, value, callback) => {
      let pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
      let isValid = pattern.test(value);
      if (!!value && !isValid) {
        callback(new Error("密码需为8位长度的大小写字母和数字"));
      } else {
        callback();
      }
    };

    return {
      submitBtnClass: "primary",
      submitBtnDisable: false,
      submitBtnStatus: {
        status: true,
        stopTime: null,
        resetStatus: function() {
          let self = this;
          clearTimeout(self.stopTime);
          self.stopTime = setTimeout(() => {
            self.status = true;
          }, 1500);
        }
      },
      showError: false,
      errorMessage: "",
      channelList: [{
          Key: "",
          Value: "暂无",
        }],
      universityList: [],
      model: this.initModel(),
      rules: {
        phone: [
          {
            required: true,
            message: "手机号不能为空",
            trigger: ["blur", "change"]
          },
          {
            validator: validatePhone,
            trigger: ["blur", "change"]
          }
        ],
        universityId: {
          required: true,
          message: "学校不能为空",
          trigger: ["blur", "change"]
        },
        password: [
          {
            required: true,
            message: "初始密码不能为空",
            trigger: ["blur", "change"]
          },
          {
            validator: validatePass,
            trigger: ["blur", "change"]
          }
        ],
        firstName: [
          {
            required: true,
            message: "请输入驾照，护照，学生证上合法的Legal Name",
            trigger: ["blur", "change"]
          }
        ],
        lastName: [
          {
            required: true,
            message: "请输入驾照，护照，学生证上合法的Legal Name",
            trigger: ["blur", "change"]
          }
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱地址",
            trigger: ["blur", "change"]
          },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  components: {
    elScsPassword
  },
  computed: {},
  created() {
    this.loadUniversityList();
    this.loadChannelList();
    this.loadData();
  },
  updated() {
    this.checkAllInputs();
  },
  methods: {
    initModel() {
      var date = new Date();
      var year = date.getFullYear();
      let newModel = {
        phone: "",
        universityId: "",
        firstName: "",
        lastName: "",
        name: "",
        email: "",
        password: `Speedup${year}`,
        channelId: ""
      };

      return newModel;
    },
    checkAllInputs() {
      let isValid = true;

      let $ref = this.$refs["model"];
      if (!!$ref) {
        $ref.validate(valid => {
          if (!valid) {
            isValid = false;
            return;
          }
        });
      }

      if (isValid) {
        this.submitBtnClass = "primary";
        this.submitBtnDisable = false;
      } else {
        this.submitBtnClass = "info";
        this.submitBtnDisable = true;
      }

      return isValid;
    },
    loadUniversityList() {
      getUniversities().then(result => {
        if (!!result && result.success) {
          this.universityList = result.data;
        } else {
          this.universityList = [];
        }
      });
    },
    loadChannelList() {
      if (this.isStudyAbroad){
        getChannelItems().then((result) => {
          if (!!result && result.success) {
            this.channelList = this.channelList.concat(result.data);
          }else{
            this.channelList = [{
              Key: "",
              Value: "暂无",
            }];
          }
        });
      }
    },
    loadData(phone) {
      if (!phone) phone = !!this.dataIn ? this.dataIn.phone : "";

      this.model = this.initModel();
      this.model.phone = phone;
    },
    reset() {
      //this.loadUniversityList();
      this.loadData();
      this.$refs["el-scs-password"].setShowPassword(false);
    },
    async registerUser() {
      if (this.submitBtnStatus.status) {
        this.submitBtnStatus.status = false;

        this.errorMessage = "";
        this.showError = false;

        let isValid = this.checkAllInputs();
        if (!isValid) return false;

        this.submitBtnDisable = true;
        let result = await userRegister(
          this.model.phone,
          this.model.code,
          this.model.universityId,
          this.model.firstName,
          this.model.lastName,
          this.model.email,
          this.model.password,
          this.model.password,
          true,
          this.model.channelId,
          this.isStudyAbroad
        );
        if (!result) {
          this.errorMessage = "未正确连接到服务器";
          this.showError = true;
        } else if (!result.success) {
          this.errorMessage = result.message;
          this.showError = true;
        } else {
          this.$message("注册成功");
          this.triggerSaveSuccess({ user: result.data });
          this.triggerClose();
        }
        this.submitBtnDisable = false;
      }

      this.submitBtnStatus.resetStatus();
    },
    triggerSaveSuccess(dataOut) {
      this.$emit("saveSuccess", dataOut);
    },
    triggerClose() {
      this.$emit("closeDialog");
    }
  },
  watch: {
    dataIn:function(){
       this.loadData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/studentRegisterEditor.vue